export default class {
	constructor() {
		this.medicalLink = '.c-card-service01__item-link.-medical';
		this.medicalSuperWideLink = '.c-card-service01__item-link.-medical_superwide';
		this.sevenLink = '.c-card-service01__item-link.-seven';
		this.threeWideLink = '.c-card-service01__item-link.-three';
		this.cancerLumpsumLink = '.c-card-service01__item-link.-cancer_lumpsum';
		this.cancerTreatmentLink = '.c-card-service01__item-link.-cancer_treatment';

		this.defaultBackground = 'url(../img/common/circle.png) no-repeat center / contain';

		this.medicalBackground = 'url(../img/common/circle_medical.png) no-repeat center / contain';
		this.medicalSuperWideBackground = 'url(../img/common/circle_medical_superwide.png) no-repeat center / contain';
		this.sevenBackground = 'url(../img/common/circle_seven.png) no-repeat center / contain';
		this.threeBackground = 'url(../img/common/circle_three.png) no-repeat center / contain';
		this.cancerLumpsumBackground = 'url(../img/common/circle_cencer_lumpsum.png) no-repeat center / contain';
		this.cancerTreatmentBackground = 'url(../img/common/circle_cancer_treatment.png) no-repeat center / contain';
		this.init();
	}

	init() {
		document.querySelectorAll(this.medicalLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.medicalBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});

		document.querySelectorAll(this.medicalSuperWideLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.medicalSuperWideBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});

		document.querySelectorAll(this.sevenLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.sevenBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});

		document.querySelectorAll(this.threeWideLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.threeBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});

		document.querySelectorAll(this.cancerLumpsumLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.cancerLumpsumBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});

		document.querySelectorAll(this.cancerTreatmentLink).forEach(link => {
			link.addEventListener('mouseover', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.cancerTreatmentBackground);
			});
			link.addEventListener('mouseleave', () => {
				document.querySelector('.p-index-service').style.setProperty('--circle-background', this.defaultBackground);
			});
		});
	}
}
